module.exports = __webpack_public_path__ + "quilt3-level2.55a9bfec.png";